import * as React from 'react'

function SearchGlassIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      {...props}
    >
      <circle cx='8' cy='8.55103' r='7' stroke='#666666' strokeWidth={2} />
      <line
        x1='1'
        y1='-1'
        x2='9'
        y2='-1'
        transform='matrix(0.747409 0.664364 -0.747409 0.664364 11.875 13.551)'
        stroke='#666666'
        strokeWidth={2}
        strokeLinecap='round'
      />
    </svg>
  )
}

export default SearchGlassIcon
